// reuse name for type checking in SelectList
const SelectOptionDisplayName = 'SelectOption';
const SelectOptionGroupDisplayName = 'SelectOptionGroup';

export { SelectOptionDisplayName as S, SelectOptionGroupDisplayName as a };
//# sourceMappingURL=displayNames-DWYGtsUp.js.map
